import { Image, SimpleGrid, Container, Title, createStyles } from "@mantine/core"

import alexFitness from "shared/assets/brands/alex-fitness.svg"
import crocus from "shared/assets/brands/crocus.svg"
import encore from "shared/assets/brands/encore.svg"
import fiftyGym from "shared/assets/brands/fifty-gym.svg"
import goldsGym from "shared/assets/brands/golds-gym.svg"
import kingFit from "shared/assets/brands/king-fit.svg"
import orangeFitness from "shared/assets/brands/orange-fitness.svg"
import territoriyaFitnesa from "shared/assets/brands/territoriya-fitnesa.svg"
import worldClass from "shared/assets/brands/world-class.svg"
import worldGym from "shared/assets/brands/world-gym.svg"
import xFit from "shared/assets/brands/x-fit.svg"
import zebraFitness from "shared/assets/brands/zebra-fitness.svg"
import React from "react"

const items = [
  alexFitness,
  crocus,
  encore,
  fiftyGym,
  goldsGym,
  kingFit,
  orangeFitness,
  territoriyaFitnesa,
  worldClass,
  worldGym,
  xFit,
  zebraFitness,
]

const useStyles = createStyles((theme) => ({
  inner: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 700,
    fontSize: "3rem",
    marginBottom: 48,

    [theme.fn.smallerThan("md")]: {
      fontSize: "2.5rem",
      marginBottom: 32,
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: "2rem",
      marginBottom: 24,
    },
  },

  container: {
    justifyContent: "center",
    alignItems: "center",

    [theme.fn.smallerThan("sm")]: {
      paddingLeft: theme.spacing.xl,
      paddingRight: theme.spacing.xl,
    },
  },
}))

export function Intro(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size="xl" className={classes.inner}>
      <Title className={classes.title} maw={768}>
        Наши выпускники работают в крупнейших фитнес-клубах России
      </Title>
      <SimpleGrid
        className={classes.container}
        cols={4}
        spacing="xl"
        breakpoints={[
          { maxWidth: "lg", cols: 4 },
          { maxWidth: "md", cols: 3 },
          { maxWidth: "sm", cols: 2 },
        ]}
      >
        {items.map((src, index) => (
          <Image maw={200} opacity={0.3} key={index} src={src}/>
        ))}
      </SimpleGrid>
    </Container>
  )
}
